module.exports = __webpack_public_path__ + "img/icon_home_new_icon_empty_10.238d7c8d.png";